import { render, staticRenderFns } from "./AccesibilityBar.vue?vue&type=template&id=1a955ef7"
import script from "./AccesibilityBar.vue?vue&type=script&lang=js"
export * from "./AccesibilityBar.vue?vue&type=script&lang=js"
import style0 from "./AccesibilityBar.vue?vue&type=style&index=0&id=1a955ef7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports